import React from 'react';
import { Modal, Row, Col } from 'react-bootstrap';

const DeleteAssignmentModal = (props) => {
  const { showModal, closeModal, handleAction } = props;

  return (
    <Modal show={showModal} onHide={closeModal} backdrop="static" className="addConflictModal">
      <Modal.Header closeButton>
          <Modal.Title>
            <Row>
              <Col md={12} className="modal-title">
                Confirmation
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="mt-4">
          <div className="text-center">
            <p>Are you sure you want to drop this student?</p>
          </div>
        </Modal.Body>
        <Modal.Footer className="mt-4">
          <button type="button" onClick={closeModal} className="btn  btn-ter pull-left">Cancel</button>
          <button className="btn btn-primary pull-right" type="submit" onClick={handleAction}>Drop</button>
        </Modal.Footer>
    </Modal>
  )
}

export default DeleteAssignmentModal;



// WEBPACK FOOTER //
// ./src/components/classes/DeleteAssignmentModal.js